import { ParseError } from "@/repositories/shared/errors/parseError";
import { injectable } from "inversify";
import { err, ok, Result } from "neverthrow";
import {
  HttpReportHistory,
  HttpReportSimpleInfo,
  IReportHistoryParser,
} from "../userRepository.types";
import { IReportHistory, IReportSimpleInfo } from "@/domain/entities/report";

function parseReportInfo(report: HttpReportSimpleInfo): IReportSimpleInfo {
  return {
    reportName: report.reportName,
    count: report.count,
    color: report.color,
  };
}

@injectable()
export class ReportHistoryParser implements IReportHistoryParser {
  toDomain(data: HttpReportHistory): Result<IReportHistory, ParseError> {
    try {
      const parsed: IReportHistory = {
        memberUid: data.memberUid,
        boardUid: data.boardUid,
        serviceUid: data.serviceUid,
        allocUid: data.allocUid,
        realOnDtm: data.realOnDtm,
        boardDate: data.boardDate,
        driveDate: data.driveDate,
        lineRouteUid: data.lineRouteUid,
        lineRouteNo: data.lineRouteNo,
        lineRouteName: data.lineRouteName,
        lineTurnUid: data.lineTurnUid,
        lineTypeName: data.lineTypeName,
        lineTypeCode: data.lineTypeCode,
        campusName: data.campusName,
        campusCode: data.campusCode,
        expectedBeginDtm: data.expectedBeginDtm,
        busOrder: data.busOrder,
        carNo: data.carNo,
        vendorName: data.vendorName,
        reportInfo: data.reportInfo?.map(parseReportInfo) ?? [],
      };

      return ok(parsed);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
